export default "__VITE_ASSET__BUxUIR4C__"